export default "__VITE_PUBLIC_ASSET__8ee44570__"